/** Admin / superviseur : employés, équipes, paie, finances, paramètres. */
export default {
  /** "Label : " (French spacing before the colon). */
  labelColon: '{{label}} :',
  employeeStatus: { ACTIVE: 'Actif', INVITED: 'Invité', ON_LEAVE: 'En congé', INACTIVE: 'Inactif' },
  skills: { STANDARD: 'Standard', DEEP: 'Nettoyage profond', MOVE: 'Déménagement', COMMERCIAL: 'Commercial', PETS_OK: 'Animaux OK' },

  employees: {
    title: 'Employés',
    subtitle: 'Équipe terrain, compétences, secteurs et charge du jour.',
    new: 'Nouvel employé',
    search: 'Rechercher par nom, courriel ou téléphone',
    allStatuses: 'Tous les statuts',
    empty: 'Aucun employé pour le moment.',
    emptyFiltered: 'Aucun employé ne correspond à ces filtres.',
    name: 'Nom',
    skills: 'Compétences',
    sectors: 'Secteurs',
    teams: 'Équipes',
    today: 'Auj.',
    jobsToday_one: '{{count}} ménage aujourd’hui',
    jobsToday_other: '{{count}} ménages aujourd’hui',
  },

  form: {
    newTitle: 'Nouvel employé',
    newSubtitle: 'Un compte employé est créé avec un mot de passe temporaire à transmettre.',
    editTitle: 'Modifier {{name}}',
    editTitleShort: 'Modifier l’employé',
    identity: 'Identité',
    fullName: 'Nom complet',
    emailHint: 'Sert d’identifiant de connexion.',
    statusHint: 'Le statut se change ensuite depuis la fiche.',
    hireDate: 'Date d’embauche',
    color: 'Couleur',
    colorHint: 'Utilisée dans le planning et sur la carte.',
    work: 'Travail',
    noSectors: 'Aucun secteur configuré (Paramètres > Secteurs).',
    dailyCapacity: 'Ménages max. par jour',
    dailyCapacityHint: 'Vide = valeur de l’entreprise.',
    maxHours: 'Heures max. par jour',
    maxHoursHint: 'Vide = valeur de l’entreprise.',
    hasVehicle: 'Possède un véhicule',
    vehicleNotes: 'Notes sur le véhicule',
    home: 'Domicile',
    homeHint: 'Point de départ pour estimer les distances (jamais visible par les clients).',
    lat: 'Latitude',
    lng: 'Longitude',
    internalNotes: 'Notes internes',
    internalNotesHint: 'Visibles par le personnel seulement.',
    createAndInvite: 'Créer et inviter',
    created: 'Employé créé.',
    saved: 'Fiche enregistrée.',
    invalid: 'Valeur invalide.',
  },

  invite: {
    title: 'Invitation',
    description: 'Transmettez ces informations de connexion à la personne.',
    email: 'Identifiant : {{email}}',
    once: 'Ce mot de passe temporaire ne sera plus affiché. La personne pourra le changer après sa première connexion.',
    copied: 'Mot de passe copié.',
    done: 'C’est noté',
    selfSignup: 'Le compte est prêt. La personne crée elle-même son mot de passe.',
    selfSignupSteps: 'Demandez-lui de s’inscrire sur {{url}} avec ce même courriel et de confirmer le lien reçu. Son compte sera relié automatiquement.',
  },

  availability: {
    title: 'Disponibilités hebdomadaires',
    off: 'Non disponible',
    start: 'Début',
    end: 'Fin',
    add: 'Plage',
    remove: 'Retirer la plage',
    invalid: 'Chaque plage doit finir après son début.',
  },

  comp: {
    title: 'Rémunération',
    edit: 'Modifier la rémunération',
    editDialogHint: 'La nouvelle règle s’applique dès aujourd’hui. L’historique est conservé.',
    createHint: 'Règle appliquée aux ménages terminés. Modifiable plus tard depuis la fiche.',
    editHint: 'Si vous changez la règle, une nouvelle règle commence aujourd’hui (l’historique est conservé).',
    method: 'Mode de calcul',
    fixed: 'Montant par ménage',
    hourly: 'Taux horaire',
    percentage: 'Pourcentage du prix client',
    percentageHint: 'Partagé entre les employés du ménage.',
    perHour: '{{amount}}/h',
    none: 'Aucune règle : les valeurs par défaut de l’entreprise s’appliquent.',
    since: 'Depuis le {{from}}',
    range: 'Du {{from}} au {{to}}',
    serviceSpecific: 'service précis',
    saved: 'Rémunération mise à jour.',
  },

  detail: {
    profile: 'Profil',
    vehicle: 'Véhicule',
    capacity: 'Capacité',
    capacityJobs: '{{count}} ménages max. par jour',
    capacityHours: '{{count}} h max. par jour',
    capacityDefault: 'Valeurs de l’entreprise',
    lastLogin: 'Dernière connexion',
    never: 'Jamais',
    sectorsTeams: 'Secteurs et équipes',
    upcoming: 'Prochains ménages',
    upcomingCount: 'À venir',
    next30: '30 prochains jours',
    noUpcoming: 'Aucun ménage prévu.',
    history: 'Historique récent',
    noHistory: 'Aucun ménage passé.',
    jobsDone: 'Ménages faits',
    timeWorked: 'Temps travaillé',
    recentHistory: '20 derniers ménages',
    payroll: 'Paie',
    changeStatus: 'Statut',
    setStatus: { ACTIVE: 'Marquer actif', ON_LEAVE: 'Mettre en congé', INACTIVE: 'Désactiver' },
    statusChanged: 'Statut mis à jour.',
    deactivate: 'Désactiver',
    deactivateTitle: 'Désactiver {{name}} ?',
    deactivateBody: 'La personne ne pourra plus se connecter. Ses ménages à venir lui seront retirés et retourneront au dispatch pour être réassignés.',
    deactivatedTitle: 'Employé désactivé',
    releasedJobs_one: '{{count}} ménage à venir est retourné au dispatch.',
    releasedJobs_other: '{{count}} ménages à venir sont retournés au dispatch.',
    openDispatch: 'Ouvrir le planning',
  },

  timeOff: {
    title: 'Congés et absences',
    add: 'Ajouter un congé',
    addHint: 'L’employé ne recevra pas de ménage pendant ces dates.',
    empty: 'Aucun congé à venir.',
    start: 'Du',
    end: 'Au',
    reason: 'Raison (facultatif)',
    range: 'Du {{from}} au {{to}}',
    invalid: 'La fin doit être après le début.',
    added: 'Congé ajouté.',
    remove: 'Retirer le congé',
    removeTitle: 'Retirer ce congé ?',
    removed: 'Congé retiré.',
  },

  teams: {
    title: 'Équipes',
    subtitle: 'Groupes d’employés qui travaillent ensemble, avec leurs secteurs et leur capacité.',
    new: 'Nouvelle équipe',
    edit: 'Modifier l’équipe',
    empty: 'Aucune équipe pour le moment.',
    name: 'Nom',
    namePlaceholder: 'Équipe Alpha',
    members: 'Membres',
    leader: 'Chef d’équipe',
    noLeader: 'Aucun chef',
    noMembers: 'Aucun membre',
    capacity: 'Ménages max. par jour',
    capacityHint: 'Vide = valeur de l’entreprise.',
    capacityValue_one: '{{count}} ménage max. par jour',
    capacityValue_other: '{{count}} ménages max. par jour',
    capacityDefault: 'Capacité par défaut de l’entreprise',
    active: 'Équipe active',
    inactive: 'Inactive',
    deactivate: 'Désactiver',
    deactivateTitle: 'Désactiver {{name}} ?',
    deactivateBody: 'L’équipe ne sera plus proposée au dispatch. Les employés restent actifs et les ménages déjà assignés ne changent pas.',
    deactivated: 'Équipe désactivée.',
    created: 'Équipe créée.',
    saved: 'Équipe enregistrée.',
  },

  payroll: {
    title: 'Paie',
    notice: 'La plateforme calcule et suit les montants dus. La paie approuvée peut être versée aux travailleurs autonomes ci-dessous ; « Marquer payé » sert à noter un paiement fait en dehors de l’application.',
    range: 'Période',
    ranges: { today: 'Aujourd’hui', week: 'Cette semaine', period: 'Période de paie', custom: 'Personnalisée' },
    rangeLabel: 'Du {{from}} au {{to}}',
    from: 'Du',
    to: 'Au',
    allEmployees: 'Tous les employés',
    totals: { pendingCents: 'En attente', approvedCents: 'Approuvé', paidCents: 'Payé' },
    byEmployee: 'Par employé',
    jobsCount_one: '{{count}} ménage',
    jobsCount_other: '{{count}} ménages',
    pendingShort: '{{amount}} en attente',
    entries: 'Lignes de paie',
    emptyEntries: 'Aucune ligne de paie pour cette période.',
    emptyHint: 'Les lignes sont créées automatiquement quand un ménage est terminé.',
    job: 'Ménage',
    method: 'Calcul',
    selectAll: 'Tout sélectionner',
    unselectAll: 'Tout désélectionner',
    selectEntry: 'Sélectionner la ligne',
    selected_one: '{{count}} ligne sélectionnée · {{amount}}',
    selected_other: '{{count}} lignes sélectionnées · {{amount}}',
    mixedHint: 'La sélection mélange des statuts : approuvez les lignes en attente et marquez payées les lignes approuvées séparément.',
    actions: { APPROVE: 'Approuver', MARK_PAID: 'Marquer payé', VOID: 'Annuler' },
    confirm: {
      APPROVE: {
        title_one: 'Approuver {{count}} ligne ?',
        title_other: 'Approuver {{count}} lignes ?',
        body_one: 'Montant total : {{amount}}. La ligne pourra ensuite être marquée payée.',
        body_other: 'Montant total : {{amount}}. Les lignes pourront ensuite être marquées payées.',
      },
      MARK_PAID: {
        title_one: 'Marquer {{count}} ligne comme payée ?',
        title_other: 'Marquer {{count}} lignes comme payées ?',
        body_one: 'Montant total : {{amount}}. Confirmez seulement si l’employé a été payé en dehors de l’application (aucun virement n’est fait ici).',
        body_other: 'Montant total : {{amount}}. Confirmez seulement si les employés ont été payés en dehors de l’application (aucun virement n’est fait ici).',
      },
      VOID: {
        title_one: 'Annuler {{count}} ligne ?',
        title_other: 'Annuler {{count}} lignes ?',
        body_one: 'Montant total : {{amount}}. La ligne ne sera plus due. Cette action est conservée dans le journal.',
        body_other: 'Montant total : {{amount}}. Les lignes ne seront plus dues. Cette action est conservée dans le journal.',
      },
    },
    voidReason: 'Raison de l’annulation',
    actionDone_one: '{{count}} ligne mise à jour.',
    actionDone_other: '{{count}} lignes mises à jour.',
  },

  finances: {
    title: 'Finances',
    actionsColumn: 'Actions',
    subtitle: 'Ventes, paiements et coûts employés du mois.',
    notice: 'Vue de gestion simplifiée pour suivre l’activité. Ce n’est pas une comptabilité certifiée : référez-vous à votre comptable pour les états financiers et les taxes.',
    prevMonth: 'Mois précédent',
    nextMonth: 'Mois suivant',
    expectedSales: 'Ventes prévues',
    completedSales: 'Ventes complétées',
    paymentsReceived: 'Paiements reçus',
    employeeCosts: 'Coûts employés',
    grossMargin: 'Marge brute opérationnelle',
    failedPayments: 'Paiements échoués',
    jobsScheduled_one: '{{count}} ménage prévu',
    jobsScheduled_other: '{{count}} ménages prévus',
    jobsCompleted_one: '{{count}} ménage terminé',
    jobsCompleted_other: '{{count}} ménages terminés',
    paymentsCount_one: '{{count}} paiement',
    paymentsCount_other: '{{count}} paiements',
    payrollPending: 'dont {{amount}} à approuver',
    marginRatio: '{{pct}} % des ventes complétées',
    marginHint: 'Ventes complétées − coûts employés',
    failedCount_one: '{{count}} paiement à régler',
    failedCount_other: '{{count}} paiements à régler',
    cancelled_one: '{{count}} ménage annulé ce mois-ci.',
    cancelled_other: '{{count}} ménages annulés ce mois-ci.',
    daily: 'Par jour : prévu et complété',
    noDaily: 'Aucun ménage ce mois-ci.',
    expected: 'Prévu',
    completed: 'Complété',
    barLabel: 'Complété {{completed}} sur {{expected}} prévus',
    payments: 'Paiements clients',
    paymentTabs: { attention: 'Échoués et en attente', paid: 'Payés' },
    noProblemPayments: 'Aucun paiement échoué ou en attente.',
    noPaidPayments: 'Aucun paiement reçu.',
    reference: 'Référence',
    refundedAmount: '{{amount}} remboursé',
    recordRefund: 'Noter un remboursement',
    refundTitle: 'Noter un remboursement',
    refundBody: 'Client : {{client}}. Montant remboursable : {{amount}}.',
    refundAmount: 'Montant remboursé',
    refundHint: 'Enregistre le remboursement dans l’application (fait chez le fournisseur de paiement).',
    refundInvalid: 'Entre 0,01 $ et {{max}}.',
    refunded: 'Remboursement enregistré.',
  },

  permissionGroups: {
    clients: 'Clients',
    properties: 'Propriétés',
    quotes: 'Soumissions',
    services: 'Services',
    jobs: 'Ménages et dispatch',
    employees: 'Employés et équipes',
    payroll: 'Paie',
    payments: 'Paiements et finances',
    chat: 'Messages',
    admin: 'Administration',
  },
  permissions: {
    'clients.read': 'Voir les clients',
    'clients.write': 'Modifier les clients',
    'properties.read': 'Voir les propriétés',
    'properties.write': 'Modifier les propriétés',
    'properties.sensitive.read': 'Voir les accès (codes, clés)',
    'quotes.read': 'Voir les soumissions',
    'quotes.write': 'Préparer les soumissions',
    'quotes.approve': 'Approuver les prix',
    'services.read': 'Voir les services',
    'services.manage': 'Gérer services et checklists',
    'jobs.read': 'Voir le planning',
    'jobs.write': 'Créer et modifier des ménages',
    'jobs.assign': 'Assigner des employés',
    'jobs.override': 'Forcer une assignation (dérogation)',
    'employees.read': 'Voir les employés',
    'employees.manage': 'Gérer les employés',
    'teams.read': 'Voir les équipes',
    'teams.manage': 'Gérer les équipes',
    'payroll.read': 'Voir la paie',
    'payroll.approve': 'Approuver la paie et la rémunération',
    'payments.read': 'Voir les paiements',
    'payments.manage': 'Gérer les paiements (remboursements)',
    'chat.read': 'Lire les messages',
    'chat.write': 'Répondre aux messages',
    'chat.assign': 'Assigner les conversations',
    'finance.read': 'Voir les finances',
    'analytics.read': 'Voir les statistiques',
    'map.read': 'Voir la carte',
    'settings.read': 'Voir les paramètres',
    'settings.manage': 'Modifier les paramètres',
    'users.manage': 'Gérer les utilisateurs',
    'owners.manage': 'Gérer les propriétaires',
    'audit.read': 'Voir le journal d’audit',
  },

  settings: {
    title: 'Paramètres',
    subtitle: 'Entreprise, planification, tarifs, paie et accès.',
    tabs: {
      company: 'Entreprise',
      planning: 'Planning',
      pricing: 'Tarification',
      payroll: 'Paie',
      notifications: 'Notifications',
      sectors: 'Secteurs',
      services: 'Services et checklists',
      users: 'Utilisateurs et permissions',
      emails: 'Courriels',
      audit: 'Journal d’audit',
    },
    readOnly: 'Lecture seule : vous n’avez pas la permission de modifier ces paramètres.',
    saved: 'Paramètres enregistrés.',
    unsaved: 'Modifications non enregistrées',
    invalid: 'Certaines valeurs sont invalides.',
    nameFr: 'Nom (français)',
    nameEn: 'Nom (anglais)',
    labelFr: 'Libellé (français)',
    labelEn: 'Libellé (anglais)',
    descriptionFr: 'Description (français)',
    descriptionEn: 'Description (anglais)',
    company: {
      title: 'Entreprise',
      description: 'Coordonnées affichées aux clients et dans les courriels.',
      name: 'Nom de l’entreprise',
      timezone: 'Fuseau horaire',
      timezoneHint: 'Toutes les heures sont affichées dans ce fuseau (America/Toronto par défaut).',
      currency: 'Devise',
      language: 'Langue par défaut',
    },
    planning: {
      hoursTitle: 'Heures d’ouverture',
      openingTime: 'Ouverture',
      closingTime: 'Fermeture',
      workingDays: 'Jours travaillés',
      bufferMinutes: 'Battement entre deux ménages (minutes)',
      bufferMinutesHint: 'Temps de déplacement minimal ajouté entre deux ménages.',
      capacityTitle: 'Capacité et distances',
      maxJobsPerEmployeePerDay: 'Ménages max. par employé et par jour',
      maxJobsPerEmployeePerDayHint: 'Peut être ajusté sur chaque fiche employé.',
      maxJobsPerTeamPerDay: 'Ménages max. par équipe et par jour',
      maxJobsPerTeamPerDayHint: 'Peut être ajusté sur chaque équipe.',
      maxHoursPerDay: 'Heures max. par employé et par jour',
      maxHoursPerDayHint: 'Au-delà, le dispatch signale un conflit.',
      maxDistanceKm: 'Distance max. du domicile (km)',
      maxDistanceKmHint: 'Les employés plus loin sont moins bien classés.',
      cutoffTitle: 'Délai de modification client',
      cutoffDescription: 'Après ce délai, le client ne peut plus modifier ni annuler lui-même : il doit écrire à l’équipe.',
      cutoffMode: 'Règle',
      cutoffModes: { HOURS: 'Nombre d’heures avant le ménage', BUSINESS_DAY: 'Jours ouvrables avant le ménage' },
      cutoffHours: 'Heures avant',
      hoursValue_one: '{{count}} heure',
      hoursValue_other: '{{count}} heures',
      cutoffBusinessDays: 'Jours ouvrables avant',
      cutoffBusinessDaysHint: '1 = au plus tard le jour ouvrable précédent.',
      recurrenceTitle: 'Ménages récurrents',
      recurrenceHorizonDays: 'Horizon de génération (jours)',
      recurrenceHorizonDaysHint: 'Nombre de jours à l’avance où les ménages récurrents sont créés dans le planning.',
    },
    pricing: {
      notice: 'Ces règles produisent une estimation interne. Le prix officiel d’une soumission est toujours fixé par l’équipe. Montants en dollars.',
      baseTitle: 'Prix de base',
      baseDescription: 'Selon le type de propriété.',
      roomsTitle: 'Prix par pièce et suppléments',
      perBedroom: 'Par chambre',
      perBathroom: 'Par salle de bain',
      perKitchen: 'Par cuisine',
      perFamilyRoom: 'Par salle familiale',
      perExtraFloor: 'Par étage supplémentaire',
      petSurcharge: 'Supplément animaux',
      sqftTitle: 'Superficie',
      sqftDescription: 'Supplément par pied carré au-delà du seuil.',
      sqftThreshold: 'Seuil (pi²)',
      perSqftAbove: 'Par pi² au-delà',
      discountsTitle: 'Rabais selon la fréquence',
      discountsDescription: 'Pourcentage retiré du prix estimé.',
      extrasTitle: 'Extras',
      extrasDescription: 'Options que le client peut ajouter (prix et temps supplémentaires).',
      extraCode: 'Code',
      extraMinutes: 'Minutes',
      addExtra: 'Ajouter un extra',
      removeExtra: 'Retirer l’extra',
      minutesTitle: 'Durée estimée (minutes)',
      minutesDescription: 'Sert à estimer la durée et la rémunération horaire.',
      minutes: {
        base: 'Base',
        perBedroom: 'Par chambre',
        perBathroom: 'Par salle de bain',
        perKitchen: 'Par cuisine',
        perFamilyRoom: 'Par salle familiale',
        perExtraFloor: 'Par étage supplémentaire',
        pets: 'Animaux',
      },
      rulesTitle: 'Règles générales',
      minimumPrice: 'Prix minimum',
      rounding: 'Arrondi au multiple de',
      secondWorker: 'Deuxième employé au-delà de (minutes)',
      secondWorkerHint: 'Au-delà de cette durée, deux employés sont recommandés.',
    },
    payroll: {
      periodTitle: 'Période de paie',
      periodDescription: 'Sert à regrouper les lignes de paie et au filtre « Période de paie ».',
      periodKind: 'Fréquence',
      kinds: { WEEKLY: 'Hebdomadaire', BIWEEKLY: 'Aux deux semaines', SEMI_MONTHLY: 'Deux fois par mois (1er et 16)', MONTHLY: 'Mensuelle' },
      anchor: 'Date de début de référence',
      anchorHint: 'Premier jour d’une période (hebdomadaire ou aux deux semaines).',
      defaultsTitle: 'Rémunération par défaut',
      defaultsDescription: 'Appliquée aux employés sans règle personnelle.',
    },
    notifications: {
      title: 'Notifications',
      description: 'Courriels envoyés aux clients et aux employés.',
      emailEnabled: 'Envoyer les courriels',
      reminderEnabled: 'Rappel avant chaque ménage',
      reminderHoursBefore: 'Heures avant le ménage',
      employeeDailySummary: 'Résumé quotidien aux employés',
    },
    sectors: {
      description: 'Zones de service (ex. Rive-Sud) et leurs secteurs (ex. Saint-Hubert). Le secteur d’une propriété est détecté à partir du centre et du rayon.',
      empty: 'Aucune zone de service.',
      newArea: 'Nouvelle zone',
      areaHint: 'Grande région qui regroupe plusieurs secteurs.',
      areaPlaceholder: 'Rive-Sud',
      areaCreated: 'Zone créée.',
      addSector: 'Secteur',
      newSector: 'Nouveau secteur',
      editSector: 'Modifier le secteur',
      noSectors: 'Aucun secteur dans cette zone.',
      area: 'Zone',
      name: 'Nom',
      areaDescription: 'Description',
      radius: 'Rayon (km)',
      radiusValue: 'rayon {{km}} km',
      centerHint: 'Centre et rayon servent à détecter automatiquement le secteur d’une adresse.',
      active: 'Secteur actif',
      inactive: 'Inactif',
      properties_one: '{{count}} propriété',
      properties_other: '{{count}} propriétés',
      saved: 'Secteur enregistré.',
      deleted: 'Secteur supprimé.',
      deleteTitle: 'Supprimer le secteur {{name}} ?',
      deleteBody: 'Le secteur sera retiré des employés et des équipes.',
      deleteInUse_one: 'Ce secteur contient encore {{count}} propriété : déplacez-la d’abord ou désactivez le secteur.',
      deleteInUse_other: 'Ce secteur contient encore {{count}} propriétés : déplacez-les d’abord ou désactivez le secteur.',
    },
    services: {
      readOnly: 'Lecture seule : la gestion des services demande la permission « Gérer services et checklists ».',
      servicesTitle: 'Types de service',
      editService: 'Modifier le service {{code}}',
      priceMultiplier: 'Multiplicateur de prix',
      durationMultiplier: 'Multiplicateur de durée',
      multiplierHint: '1 = prix standard, 1,5 = 50 % plus cher.',
      multipliers: 'Prix ×{{price}} · Durée ×{{duration}}',
      defaultTemplate: 'Checklist par défaut',
      active: 'Service offert',
      inactive: 'Non offert',
      saved: 'Service enregistré.',
      templatesTitle: 'Checklists',
      newTemplate: 'Nouvelle checklist',
      editTemplate: 'Modifier la checklist',
      noTemplates: 'Aucune checklist.',
      code: 'Code',
      codeHint: 'Majuscules, chiffres et _ seulement.',
      templateDescription: 'Description',
      addTask: 'Tâche',
      required: 'Obligatoire',
      optional: 'facultative',
      itemsInvalid: 'Chaque tâche doit avoir un libellé en français et en anglais.',
      taskCount_one: '{{count}} tâche',
      taskCount_other: '{{count}} tâches',
      templateSaved: 'Checklist enregistrée.',
    },
    users: {
      staffTitle: 'Personnel administratif',
      new: 'Nouvel utilisateur',
      newHint: 'Administrateur ou superviseur. Un mot de passe temporaire sera affiché une seule fois.',
      invite: 'Créer et inviter',
      created: 'Utilisateur créé.',
      role: 'Rôle',
      you: 'Vous',
      inactive: 'Désactivé',
      lastLogin: 'Dernière connexion : {{date}}',
      neverLoggedIn: 'Jamais connecté',
      overridesCount: '{{granted}} ajout(s), {{revoked}} retrait(s)',
      permissions: 'Permissions',
      overridesTitle: 'Permissions de {{name}}',
      overridesHint: 'Par défaut, la personne a les permissions du rôle {{role}}. Ajoutez ou retirez des permissions pour elle seulement.',
      defaultYes: 'Par défaut (oui)',
      defaultNo: 'Par défaut (non)',
      grant: 'Accorder',
      revoke: 'Retirer',
      permissionsSaved: 'Permissions enregistrées.',
      activate: 'Réactiver',
      deactivate: 'Désactiver',
      deactivateTitle: 'Désactiver {{name}} ?',
      deactivateBody: 'La personne ne pourra plus se connecter. Vous pourrez la réactiver plus tard.',
      activeSaved: 'Accès mis à jour.',
    },
    roles: {
      title: 'Permissions par rôle',
      description: 'Le superviseur utilise la même interface que l’administrateur : ce qu’il ne peut pas faire disparaît.',
      ownerHint: 'Le propriétaire a toujours toutes les permissions.',
      notEditable: 'Seul un propriétaire peut modifier les permissions de ce rôle.',
      saved: 'Permissions du rôle enregistrées.',
    },
    outbox: {
      description: 'Courriels générés par l’application (fournisseur de développement : rien n’est réellement envoyé, le contenu est visible ici).',
      refresh: 'Actualiser',
      empty: 'Aucun courriel pour le moment.',
      scheduledFor: 'Prévu : {{date}}',
      sentAt: 'Envoyé : {{date}}',
      error: 'Échec après {{attempts}} tentative(s) : {{error}}',
      notRendered: 'Contenu non encore généré.',
      status: { PENDING: 'En attente', PROCESSING: 'En cours', SENT: 'Envoyé', FAILED: 'Échec', CANCELLED: 'Annulé' },
      types: {
        CLIENT_ACCOUNT_CREATED: 'Compte client créé',
        QUOTE_AVAILABLE: 'Soumission disponible',
        QUOTE_ACCEPTED: 'Soumission acceptée',
        BOOKING_CONFIRMED: 'Réservation confirmée',
        BOOKING_CHANGED: 'Réservation modifiée',
        BOOKING_CANCELLED: 'Réservation annulée',
        JOB_REMINDER: 'Rappel de ménage',
        JOB_COMPLETED: 'Ménage terminé',
        PAYMENT_RECEIVED: 'Paiement reçu',
        PAYMENT_FAILED: 'Paiement échoué',
        EMPLOYEE_JOB_ASSIGNED: 'Ménage assigné (employé)',
        EMPLOYEE_SCHEDULE_CHANGED: 'Horaire modifié (employé)',
        EMPLOYEE_JOB_CANCELLED: 'Ménage annulé (employé)',
        EMPLOYEE_DAILY_SUMMARY: 'Résumé quotidien (employé)',
        NEW_MESSAGE: 'Nouveau message',
      },
    },
    audit: {
      description: 'Qui a fait quoi, et quand. Les changements sensibles (prix, paie, permissions, statuts) sont conservés ici.',
      allEntities: 'Tous les éléments',
      entity: 'Élément',
      actor: 'Par',
      action: 'Action',
      change: 'Avant → après',
      system: 'Système',
      empty: 'Aucune entrée.',
      entities: {
        employee: 'Employé',
        team: 'Équipe',
        payroll_entry: 'Paie',
        job: 'Ménage',
        quote: 'Soumission',
        agreement: 'Entente',
        client: 'Client',
        property: 'Propriété',
        payment: 'Paiement',
        conversation: 'Conversation',
        business_settings: 'Paramètres',
        sector: 'Secteur',
        service_area: 'Zone de service',
        service_type: 'Type de service',
        task_template: 'Checklist',
        user: 'Utilisateur',
        role: 'Rôle',
      },
    },
  },
};
